import { render } from "./HeaderMaridador.vue?vue&type=template&id=cb40ce20&scoped=true"
import script from "./HeaderMaridador.vue?vue&type=script&lang=js"
export * from "./HeaderMaridador.vue?vue&type=script&lang=js"

import "./HeaderMaridador.vue?vue&type=style&index=0&id=cb40ce20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb40ce20"]])

export default __exports__